import React from 'react'
import classnames from 'classnames'
import DealHeader from "./DealHeader";
import {DealPageFees} from "./DealPageFees";
import {DealPagePayment} from "./DealPagePayment";
import {useDealContext} from "../../contexts/DealContext";
import {DealPageRebates} from "./DealPageRebates";

import Box from "@mui/material/Box";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import Stack from "@mui/material/Stack";
import {DealPageInfo} from "./DealPageInfo";
import './DealPage.scss'
import {DealPageTaxes} from "./DealPageTaxes";
import {DealPageNotes} from "./DealPageNotes";
import {DealPageStructure} from "./DealPageStructure";
import {DealPagePaymentSummary} from "./DealPagePaymentSummary";
import {DealPageTradeIn} from "./DealPageTradeIn";
import {useThemeStore} from "../../stores/themeStore";

export const DealPage = ( { isModal, isOpen, setIsOpen } ) => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const { dealState, setDealStateWithUpdate, dealPageRef, updateDealResponse, isHistorical } = useDealContext()
    const theme = useThemeStore((state) => state.theme)

    if (!dealState) return null;

    const isPurchase = dealState.is_purchase
    // A purchase that's one_pay is cash; a purchase that isn't is finance.
    // Lease (!is_purchase) keeps the system blue — no class needed.
    const isCash    = isPurchase &&  Boolean(dealState.is_one_pay)
    const isFinance = isPurchase && !Boolean(dealState.is_one_pay)
    const isLoading = Boolean(updateDealResponse?.loading)

    return (
        <Box
            id={"DealPage"}
            data-theme={theme}
            className={classnames('', {
                isPurchase: isPurchase,
                'is-loading': isLoading,
                'deal-finance': isFinance,
                'deal-cash':    isCash,
                // Historical Current Vehicle: neutralises the blue action icons.
                // Presentation only — the read-only guarantee is in DealContext.
                'current-vehicle': isHistorical,
            })}
        >
            <Box>
                <div>
                    <div ref={dealPageRef}/>
                    <DealHeader
                        isModal={isModal}
                        dealState={dealState}
                        setDealStateWithUpdate={setDealStateWithUpdate}
                    />

                    <div className={'deal-grid'}>
                        <DealPageInfo
                            dealState={dealState}
                            setDealStateWithUpdate={setDealStateWithUpdate}
                        />
                        <DealPagePayment isDealPage={true}/>
                        <div className={'left-stack'}>
                            <DealPageNotes/>
                            <DealPageTradeIn/>
                        </div>
                        <DealPageStructure/>
                        <DealPagePaymentSummary/>
                        <div className={'bottom-sections-wrap'}>
                            <DealPageRebates/>
                            <DealPageFees/>
                            <DealPageTaxes/>
                        </div>
                    </div>
                </div>
            </Box>
        </Box>
    )
}